import React, {
  Children, cloneElement, useState, useEffect,
} from 'react';
import PropTypes from 'prop-types';

const AccordionGroup = ({
  children, current, onAccordionToggle, isValid,
}) => {
  const [currentAccordion, setCurrentAccordion] = useState(current);

  useEffect(() => {
    setCurrentAccordion(current);
  }, [current]);

  const handleToggle = (e) => {
    if (isValid) {
      setCurrentAccordion(currentAccordion === e ? null : e);
      onAccordionToggle(currentAccordion === e ? null : e);
    }
  };

  return (
    <div className="nw-accordion-group">
      {Children.map(children, (child, i) => cloneElement(child, { isOpen: currentAccordion === i, onAccordionToggle: () => handleToggle(i) }))}
    </div>
  );
};

AccordionGroup.propTypes = {
  /** accordion child */
  children: PropTypes.node,
  /** current accordion */
  current: PropTypes.number,
  /** event */
  onAccordionToggle: PropTypes.func,
  /** is accordion valid */
  isValid: PropTypes.bool,
};

AccordionGroup.defaultProps = {
  children: null,
  current: 0,
  onAccordionToggle: () => {},
  isValid: true,
};

export default AccordionGroup;
